import { AppBar, Box, Stack, Toolbar } from "@mui/material";
import { CustomLogo } from "../components/images/Logo";
import { Outlet } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
  useLogout,
  useSetPermissions,
} from "../hooks";
import { selectAuth, setAuth } from "../features/authSlice";
import { useEffect, useState } from "react";
import { useGetUserQuery, useLoginWithLinkMutation } from "../api";
import { toast } from "react-toastify";
import { CustomToast } from "../components/ui/CustomToast";
import { CustomLoader } from "../components/ui/CustomLoader";
import LoginPage from "../pages/LoginPage";

export const PublicLayout = () => {
  // const dispatch = useAppDispatch();
  // const { accessToken } = useAppSelector(selectAuth);
  //
  // const [isLoading, setIsLoading] = useState<boolean>(true);
  //
  // const logout = useLogout();
  // const [loginWithLink] = useLoginWithLinkMutation();
  // const { currentData: user, isLoading: isUserLoading } = useGetUserQuery(
  //   undefined,
  //   { skip: !accessToken },
  // );
  //
  // useSetPermissions(user?.permissions);

  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const token = urlParams.get("login_link_token");
  //   const email = urlParams.get("email");
  //
  //   if (token && email) {
  //     setIsLoading(true);
  //     loginWithLink({ email, token })
  //       .unwrap()
  //       .then((data) => {
  //         localStorage.setItem("success", "is login");
  //         dispatch(
  //           setAuth({
  //             accessToken: data.access_token,
  //             refreshToken: data.refresh_token,
  //           }),
  //         );
  //
  //         toast.success(
  //           <CustomToast
  //             type="success"
  //             text="You’ve successfully logged in using a temporary access link."
  //             title="Welcome back!"
  //           />,
  //         );
  //       })
  //       .catch(() => {
  //         toast.error(
  //           <CustomToast
  //             type="error"
  //             text="The temporary login link is no longer valid. Request a new one to access the platform."
  //             title="This link has expired"
  //           />,
  //         );
  //         logout();
  //       });
  //     setIsLoading(false);
  //   } else {
  //     setIsLoading(false);
  //   }
  // }, []);

  return (
    <>
      <AppBar
        position="sticky"
        color="default"
        sx={{
          background: "#F7F7F7",
          height: "74px",
          boxShadow: "0",
          px: 2,
          justifyContent: "center",
          top: 0,
        }}
      >
        <Toolbar>
          <Box>
            <CustomLogo />
          </Box>
        </Toolbar>
      </AppBar>
      <Stack
        sx={{
          px: { sm: 8, md: 8, lg: 10, xl: 20 },
          minHeight: "Calc(100vh - 74px)",
          paddingTop: 0,
        }}
        gap="40px"
      >
        {/*{isLoading || isUserLoading ? (*/}
        {/*  <CustomLoader />*/}
        {/*) : user ? (*/}
        {/*  <Outlet />*/}
        {/*) : (*/}
        {/*  <LoginPage />*/}
        {/*)}*/}

        <Outlet />
      </Stack>
    </>
  );
};
